import { Outlet } from 'react-router-dom'
export const Root = () => <Outlet />
